import { ClearFilters } from "@/app/ClearFilters";
import { nameOptions } from "@/app/queries";
import { Combobox, FILTER_W, Input, Toolbar } from "@/ui";
import { EMPTY_PRICE_FILTERS, type PriceFilterValues } from "./priceFilterState";

interface Props {
  ownerLabel: string;
  entityLabel: string;
  entitySearch: string;
  owners?: { id: number; name: string }[];
  entities?: { id: number; name: string; ownerId: number; system_id?: string }[];
  value: PriceFilterValues;
  onChange: (value: PriceFilterValues) => void;
}

/** 两种价格共用筛选栏，切换所有者清空下级选择，MCC/MNC 保持手动输入；有条件时显示清除筛选（#541）。 */
export function PriceFilters({ ownerLabel, entityLabel, entitySearch, owners, entities, value, onChange }: Props) {
  const entityOptions = nameOptions(entities?.filter((e) => !value.ownerId || String(e.ownerId) === value.ownerId)
    .map((e) => ({ ...e, customer_id: e.ownerId })), owners);
  return (
    <Toolbar actions={Object.values(value).some(Boolean) && <ClearFilters onClear={() => onChange(EMPTY_PRICE_FILTERS)} />}>
      <Combobox size="sm" width={FILTER_W.select} searchPlaceholder={`搜索${ownerLabel}名称或 ID`} options={[{ value: "", label: `全部${ownerLabel}` }, ...nameOptions(owners)]} value={value.ownerId} onChange={(ownerId) => onChange({ ...value, ownerId, entityId: "" })} />
      <Combobox size="sm" width={FILTER_W.select} searchPlaceholder={entitySearch} options={[{ value: "", label: `全部${entityLabel}` }, ...entityOptions]} value={value.entityId} onChange={(entityId) => onChange({ ...value, entityId })} />
      <Input size="sm" mono style={{ width: FILTER_W.code }} aria-label="筛选 MCC" placeholder="MCC" inputMode="numeric" value={value.mcc} onChange={(e) => onChange({ ...value, mcc: e.target.value })} />
      <Input size="sm" mono style={{ width: FILTER_W.code }} aria-label="筛选 MNC" placeholder="MNC" inputMode="numeric" value={value.mnc} onChange={(e) => onChange({ ...value, mnc: e.target.value })} />
    </Toolbar>
  );
}
